// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "stChH_stateChange", inline: true, disabled: false };
const msgs = {
  change: (CHANGE) => [`active page:`, CHANGE],
};

// —————————————————————————————————————————— HDL. DEF. ——————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function stChH_activePage(CHANGES) {
  //////////////////// Setup /////////////////////
  ////////////////////////////////////////////////

  const { activePage } = CHANGES;
  const { links } = this.ref;
  this.logger("state-change", msgs.change(activePage), "default", { ...logArgs, inline: false });

  //////////// State change execution ////////////
  ////////////////////////////////////////////////

  // Menu closing on page change //
  ////////////////////////////////////

  this.element.dataset.menuOpen = "false";

  //////// Active link updt. /////////
  ////////////////////////////////////

  links.forEach((l) => (l.dataset.active = l.dataset.id === activePage ? "true" : "false"));

  ////// Doc. body attr. updt. ///////
  ////////////////////////////////////

  document.body.dataset.activePage = activePage;
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
